import { Option } from "@opendaw/lib-std";
export var RemoteProjectAPI;
(function (RemoteProjectAPI) {
    const root = () => import.meta.env?.VITE_CUSTOM_SAMPLE_API_URL ?? "";
    const secret = () => import.meta.env?.VITE_PROJECT_API_SECRET ?? "";
    const authHeaders = () => ({ "Authorization": `Bearer ${secret()}` });
    RemoteProjectAPI.list = async (password) => {
        const response = await fetch(`${root()}/api/projects`, {
            headers: { ...authHeaders(), "X-Workshop-Password": password }
        });
        if (response.status === 401) {
            throw new Error("unauthorized");
        }
        if (!response.ok) {
            throw new Error(`list projects failed: ${response.status}`);
        }
        return response.json();
    };
    RemoteProjectAPI.upload = async (uuid, data, meta) => {
        const params = new URLSearchParams({ artist: meta.artist, name: meta.name });
        const response = await fetch(`${root()}/api/projects/${uuid}?${params}`, {
            method: "POST",
            headers: { ...authHeaders(), "Content-Type": "application/octet-stream" },
            body: data
        });
        if (!response.ok) {
            throw new Error(`upload project failed: ${response.status}`);
        }
    };
    RemoteProjectAPI.download = async (uuid, password) => {
        const response = await fetch(`${root()}/api/projects/${uuid}`, {
            headers: { ...authHeaders(), "X-Workshop-Password": password }
        });
        if (response.status === 401) {
            throw new Error("unauthorized");
        }
        if (!response.ok) {
            throw new Error(`download project failed: ${response.status}`);
        }
        return response.arrayBuffer();
    };
    RemoteProjectAPI.uploadMp3 = async (uuid, data, meta) => {
        const params = new URLSearchParams({ artist: meta.artist, name: meta.name });
        const response = await fetch(`${root()}/api/projects/${uuid}/mp3?${params}`, {
            method: "POST",
            headers: { ...authHeaders(), "Content-Type": "audio/mpeg" },
            body: data
        });
        if (!response.ok) {
            throw new Error(`upload mp3 failed: ${response.status}`);
        }
    };
    RemoteProjectAPI.uploadDefault = async (data, password) => {
        const response = await fetch(`${root()}/api/default-project`, {
            method: "POST",
            headers: { ...authHeaders(), "Content-Type": "application/octet-stream", "X-Workshop-Password": password },
            body: data
        });
        if (response.status === 401) {
            throw new Error("unauthorized");
        }
        if (!response.ok) {
            throw new Error(`upload default project failed: ${response.status}`);
        }
    };
    RemoteProjectAPI.downloadDefault = async () => {
        const response = await fetch(`${root()}/api/default-project`, { headers: authHeaders() });
        if (response.status === 404) {
            return Option.None;
        }
        if (!response.ok) {
            throw new Error(`download default project failed: ${response.status}`);
        }
        return Option.wrap(await response.arrayBuffer());
    };
})(RemoteProjectAPI || (RemoteProjectAPI = {}));
